import { jsx as c } from "react/jsx-runtime";
import r from "react";
import { Button as o } from "./button.js";
const t = r.forwardRef(({ ...n }, e) => /* @__PURE__ */ c(o, { buttonType: "icon", ref: e, ...n })), m = Object.assign(t, {
  Spinner: o.Spinner,
  Icon: o.Icon
});
t.displayName = "IconButton";
export {
  m as IconButton
};
//# sourceMappingURL=icon-button.js.map
